import { AlertGateway } from './alert-gateway.interface';

const baseUrl = 'gk/alerts';
export class HttpAlertGateway implements AlertGateway {
  getAllAlerts(args: { groupName: string }) {
    return {
      url: `${baseUrl}`,
      method: 'GET',
      params: { groupName: args.groupName },
    };
  }

  patchAlertAsSeen(args: { alertId: string }) {
    return { url: `${baseUrl}/${args.alertId}/seen`, method: 'PATCH' };
  }
}
